const Storage = require('utils/localStorage/Storage');
const LOCAL_STORAGE = require('utils/localStorage/Constants');

function flushUser() {
    Storage.local.removeItem(LOCAL_STORAGE.USER_DATA);
    Storage.local.removeItem(LOCAL_STORAGE.CREDIT_CARD_REALTIME_PRESCREEN);
    Storage.local.removeItem(LOCAL_STORAGE.CREDIT_CARD_TARGETERS);
    Storage.local.removeItem(LOCAL_STORAGE.JWT_AUTH_TOKEN);
}

function flushAuthTokens() {
    Storage.local.removeItem(LOCAL_STORAGE.AUTH_ACCESS_TOKEN);
    Storage.local.removeItem(LOCAL_STORAGE.AUTH_REFRESH_TOKEN);
}

function flushBasket() {
    Storage.local.removeItem(LOCAL_STORAGE.BASKET);
}

function flushPersonalizedPromotions() {
    Storage.local.removeItem(LOCAL_STORAGE.PERSONALIZED_PROMOTIONS);
}

function flushCatNav() {
    Storage.local.removeItem(LOCAL_STORAGE.CATNAV);
    Storage.local.removeItem(LOCAL_STORAGE.CAT_NAV_LOCALE);
}

function flushUserAdditionalData() {
    Storage.local.removeItem(LOCAL_STORAGE.LITHIUM_DATA);
    Storage.local.removeItem(LOCAL_STORAGE.LOVES_DATA);
    Storage.local.removeItem(LOCAL_STORAGE.CREATED_NEW_USER);
    Storage.local.removeItem(LOCAL_STORAGE.HAS_SEEN_UPDATED_SHIPPING_CALCULATIONS);
    Storage.session.removeItem(LOCAL_STORAGE.IS_FREE_FLASH_MODAL_SEEN);
    Storage.local.removeItem(LOCAL_STORAGE.JWT_AUTH_TOKEN);
}

function flushLoginProfileWarnings() {
    Storage.local.removeItem(LOCAL_STORAGE.POSTPONE_LOGIN_PROFILE_WARNINGS);
    Storage.local.removeItem(LOCAL_STORAGE.LOGIN_PROFILE_WARNINGS);
}

module.exports = {
    flushUser,
    flushAuthTokens,
    flushBasket,
    flushPersonalizedPromotions,
    flushCatNav,
    flushUserAdditionalData,
    flushLoginProfileWarnings
};
